import React from 'react';
import CardsGrid from "../CardsGrid";
import Grid from "../Grid";
import Card from "../Card";
import Container from "../Container";
import IconEditPdf from "../../public/images/edit-2.svg";
import IconFillSign from "../../public/images/sign.svg";
import IconCreateForms from "../../public/images/forms.svg";
import IconDeletePages from "../../public/images/delete-2.svg";
import {useTranslation} from "next-i18next";

const GridEditSign = () => {
  const { t } = useTranslation(['common', 'index', 'edit-pdf']);

  return (
    <Container className="mt-xs-3 mb-xs-3 mb-md-4">
      <h3>{t('index:edit-sign.title')}</h3>
      <CardsGrid>
        {/* Edit PDF / Fill & Sign / Create Forms — режимы единого редактора на
            "/" (панели edit/sign/form внутри PdfEditor), а не отдельные
            страницы-инструменты. Параметр ?tool= открывает нужную панель после
            загрузки файла (см. PdfEditor). */}
        <Grid.Item>
          <Card
            href="/"
            title={t('common:cards.edit.title')}
            text={t('common:cards.edit.text')}
            size='md'
            icon={IconEditPdf}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/?tool=sign"
            title={t('common:cards.fill-sign.title')}
            text={t('common:cards.fill-sign.text')}
            size='md'
            icon={IconFillSign}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/?tool=form"
            title={t('common:cards.create-forms.title')}
            text={t('common:cards.create-forms.text')}
            size='md'
            icon={IconCreateForms}
          />
        </Grid.Item>
        <Grid.Item>
          {/* TEA-8766: было href="/compress-pdf" (уводило в Compress). Теперь
              ведёт на новую страницу /delete-pages с рабочим удалением страниц. */}
          <Card
            href="/delete-pages"
            title={t('common:cards.delete-pages.title')}
            text={t('common:cards.delete-pages.text')}
            size='md'
            icon={IconDeletePages}
          />
        </Grid.Item>
      </CardsGrid>
    </Container>
  );
};

export default GridEditSign;
